// apps/share-web/src/chart/theme.ts
//
// Тема чтения (words page v2): `data-theme="light" | "dark"` на <html>, чтобы и
// страница слов, и слой чтения (он стоит в body) взяли один набор токенов
// (styles/theme-light.css). «Auto» — по системной настройке через matchMedia и
// следит за её сменой: телефон переключился в тёмное вечером — лист тоже.
//
// Стампуется ВСЕГДА явное значение (light/dark), а не «ничего» для auto:
// токены слоя объявлены под `[data-theme="light"]`, и не стампованный документ
// остался бы тёмным независимо от системы.
//
// Волна E, находка 2 ревью: вместе с `data-theme` ставится `color-scheme` —
// им UA красит СВОЙ хром (выпадающий список нативного <select>, полосы
// прокрутки, поля). Он был прибит к dark в index.html и base.css, и на
// светлой библиотеке тап по имени команды открывал чёрный пикер.

import type { ReaderTheme } from './reader-prefs.js';

export interface ThemeEnv {
  root?: HTMLElement | null;
  /** `window.matchMedia` или подмена; отсутствие — Auto считается тёмной. */
  matchMedia?: ((q: string) => { matches: boolean; addEventListener?(type: 'change', cb: () => void): void; removeEventListener?(type: 'change', cb: () => void): void }) | null;
}

export interface ThemeHandle { stop(): void; }

const LIGHT_QUERY = '(prefers-color-scheme: light)';

function defaultEnv(): Required<ThemeEnv> {
  return {
    root: typeof document !== 'undefined' ? document.documentElement : null,
    matchMedia: typeof matchMedia === 'function' ? (q) => matchMedia(q) : null,
  };
}

/**
 * Ставит ОБА признака темы разом: `data-theme` для наших токенов и
 * `color-scheme` для UA-хрома — нативных выпадающих списков (переключатель
 * команды в библиотеке — обычный <select>), полос прокрутки, полей ввода.
 * Раньше второй был прибит к dark в `<meta>` и в base.css ДС, и на светлой
 * странице ОС рисовала чёрный пикер. Инлайновое свойство бьёт и meta, и
 * правило base.css по приоритету, и его ставит тот же код, что ставит
 * data-theme, — разойтись им нечем. Общий пакет не трогаем: десктоп тёмный
 * всегда.
 */
function stampMode(root: HTMLElement, mode: 'light' | 'dark'): void {
  root.dataset.theme = mode;
  root.style.setProperty('color-scheme', mode);
}

/** Применить тему и (для Auto) следить за системой. Возвращает `stop` — снять слушатель. */
export function applyTheme(theme: ReaderTheme, env: ThemeEnv = {}): ThemeHandle {
  const e = { ...defaultEnv(), ...env };
  const root = e.root;
  if (!root) return { stop() {} };
  if (theme !== 'auto') {
    stampMode(root, theme);
    return { stop() {} };
  }
  const mq = e.matchMedia ? e.matchMedia(LIGHT_QUERY) : null;
  const stamp = (): void => { stampMode(root, mq && mq.matches ? 'light' : 'dark'); };
  stamp();
  if (mq && typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', stamp);
    return { stop() { mq.removeEventListener?.('change', stamp); } };
  }
  return { stop() {} };
}
